export default "__VITE_ASSET__Dbk5KC$K__"